import { Component } from '@angular/core';
import { IonicPage, NavController } from 'ionic-angular';
import { DragulaService } from "ng2-dragula/ng2-dragula"
import { Subscription } from 'rxjs';
import autoScroll from 'dom-autoscroller';
import * as $ from 'jquery';

@IonicPage()
@Component({
  selector: 'page-homedue',
  templateUrl: 'homedue.html'
})
export class HomePageDue {

  q1 = [];
  q2 = [];
  risp1 = [];
  risp2 = [];
  spazi = [];
  subs = new Subscription();
  constructor(
    navCtrl: NavController,
    private dragulaService: DragulaService
  ) {

    for (var i = 0; i < 5; i++) {
      this.q1.push("1...." + i)
    }

    this.spazi = [['casa','lista1'],['cosa','lista2','lista3']];
    dragulaService.drop.subscribe((value) => {
      // //console.log(value)
    });

    // this is to prevent 'bag already exists error'
    // https://github.com/valor-software/ng2-dragula/issues/442
    const bag: any = this.dragulaService.find('bag');
    if (bag !== undefined) this.dragulaService.destroy('bag');

    dragulaService.setOptions('bag', {
      resetOnSpill: true
    });

    const baga: any = this.dragulaService.find('baga');
    if (baga !== undefined) this.dragulaService.destroy('baga');


    this.dragulaService.dropModel.subscribe((x) => {
      // //console.log(this.risp1.length);

    })

    this.dragulaService.drop.subscribe((x) => {

      if (this.risp1.length >= 1) {
        //console.log('risp1 pieno');
        //console.log('destinazione', x[2]);
        //console.log('sorgente', x[3]);
        //console.log('elemento', x[1]);

        //if(this.risp1[0] != null && this.risp1[0] != '' && this.risp1[0] != undefined){
        this.q1.push(this.risp1[0]);
        this.risp1.pop();
        //}
      }
      if (this.risp2.length >= 1) {
        //console.log('risp2 pieno');

      }
    })
    dragulaService.dragend.subscribe((value) => {
      this.onDragEnd(value.slice(1));
    });

    dragulaService.setOptions('baga', {
      resetOnSpill: true
    });




  }
  onDragEnd(args) {
    //console.log("Drag has ended");
    $('.step-container').css({ 'overflow': 'scroll' });
  }
  ionViewDidLoad() {
    //My container that I want to scroll has the class .step-container
    autoScroll(document.querySelector('.step-container'), {
      margin: 30,
      maxSpeed: 10,
      scrollWhenOutside: true,
      autoScroll: function () {
        //console.log("Dragging", this.scrolling, this.down);
        if (this.down) {
          $('.step-container').css({ 'overflow': 'hidden' });
        } else {
          $('.step-container').css({ 'overflow': 'scroll' });
        }
        return this.down;
      }
    })
  }
  changerisp() {
    //console.log('change');
  }
  print_lista() {
    //console.log(this.q1);
    //console.log(this.q2);
  }

  print_risp() {
    //console.log(this.risp1);
    //console.log(this.risp2);
  }

}



// WEBPACK FOOTER //
// ./src/pages/homedue/homedue.ts